import { type ElementProps, Paper, type PaperProps, Title } from '@mantine/core';
import styles from './styles.module.css';

interface Props extends PaperProps, ElementProps<'div', keyof PaperProps> {}

export const ContentCard = ({ children, ...props }: Props) => {
	return (
		<Paper radius={10} withBorder {...props} className={styles.paper}>
			{props.title && (
				<Title order={3} mb={10} mt={5} fw={900} c="blue.9">
					{props.title}
				</Title>
			)}
			{children}
		</Paper>
	);
};
